"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncSome = exports.migrate = exports.castToPrimitive = exports.doDelay = exports.doComment = exports.isPrimitive = exports.SKIPPED = void 0;
const lodash_1 = require("lodash");
exports.SKIPPED = 'skipped';
function isPrimitive(val) {
    return lodash_1.isString(val) || lodash_1.isNumber(val) || lodash_1.isBoolean(val);
}
exports.isPrimitive = isPrimitive;
function doComment(message) {
    return {
        type: 'comment',
        message,
    };
}
exports.doComment = doComment;
function doDelay(time) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    });
}
exports.doDelay = doDelay;
function castToPrimitive(val) {
    const num = +val;
    if (!isNaN(num)) {
        return num;
    }
    if (val === 'true') {
        return true;
    }
    if (val === 'false') {
        return false;
    }
    return val;
}
exports.castToPrimitive = castToPrimitive;
let counter = 0;
function cleanUpExecutable(executable) {
    if (executable.class === 'executionGroup') {
        // clean up executin group
        return Object.assign(Object.assign({}, lodash_1.omit(executable, ['help', 'functions', 'label'])), { refId: `exGroup${counter++}`, ['functions']: executable.functions.map((fn) => cleanUpExecutable(fn)) });
    }
    else {
        // clean up basic function
        return Object.assign(Object.assign({}, lodash_1.omit(executable, ['help', 'label'])), { refId: `bf${counter++}` });
    }
}
function migrate(old) {
    const migrated = {};
    counter = 0;
    try {
        const changedKeys = ['graph'];
        Object.keys(old).forEach((key) => {
            if (changedKeys.indexOf(key) === -1) {
                migrated[key] = old[key];
            }
        });
        migrated.graph = {};
        // cleanup edges, remove guards from edges
        migrated.graph.edges = old.graph.edges.map((_a) => {
            var { guards } = _a, rest = __rest(_a, ["guards"]);
            return rest;
        });
        // clean up nodes, omit roles and clean up function (basicFunction or executionGroup)
        migrated.graph.nodes = old.graph.nodes.map((node) => {
            const restProps = lodash_1.omit(node, ['roles', 'function']);
            return Object.assign(Object.assign({}, restProps), { ['function']: cleanUpExecutable(node['function']) });
        });
    }
    catch (err) {
        return {
            migrate: false,
            reason: err,
        };
    }
    return {
        migrate: true,
        lesson: migrated,
    };
}
exports.migrate = migrate;
const asyncSome = (arr, predicate) => __awaiter(void 0, void 0, void 0, function* () {
    for (let e of arr) {
        if (yield predicate(e))
            return true;
    }
    return false;
});
exports.asyncSome = asyncSome;
//# sourceMappingURL=data:application/json;base64,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